<template>
  <div class="slider-block">
    <span class="raw active" @click="switchToRaw()">
      Raw JSON
    </span>
    <label class="switch">
      <input type="checkbox" @change="switchView($event.target.checked)" ref="switch" :checked="false">
      <span class="slider"></span>
    </label>
    <span class="form" @click="switchToForm()">
      Form Editor
    </span>
    <tooltip :text="TOOLTIP_TEXT.SWITCH_VIEW"></tooltip>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import { MESSAGES, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { Bus } from "../main";

export default {
  name: "FormSwitch",
  props: {
    changeView: {
      type: Boolean,
    },
  },
  data() {
    return {
      EDITOR_VIEW_RAW: MESSAGES.EDITOR_VIEW_RAW,
      EDITOR_VIEW_FORM: MESSAGES.EDITOR_VIEW_FORM,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    }
  },
  components: {
    "tooltip": Tooltip,
  },
  watch: {
    changeView: function () {
      const buttons = Array.from(
        document.querySelectorAll(".app-button > button")
      );
      buttons.forEach((button) => {
        if (button.classList.contains("selected")) {
          button.classList.remove("selected");
        } else {
          button.classList.add("selected");
        }
      });
    },
  },
  mounted() {
    // emit from Home
    Bus.$on("cancelSwitch", () => {
      const checked = this.$refs.switch.checked;
      this.$refs.switch.checked = !checked;
      if (!checked) {
        // change to Form Editor
        this.switchFontColor(this.EDITOR_VIEW_FORM);
      } else {
        // change to Raw JSON
        this.switchFontColor(this.EDITOR_VIEW_RAW);
      }
    })
  },
  methods: {
    switchView: function (checked) {
      let view;
      if (checked) {
        // change to Form Editor
        view = this.EDITOR_VIEW_FORM;
      } else {
        // change to Raw JSON
        view = this.EDITOR_VIEW_RAW;
      }
      this.switchFontColor(view);
      this.$emit("switchView", view);
    },
    switchFontColor: function (view) {
      if (view === this.EDITOR_VIEW_RAW) {
        this.$el.querySelector(".form").classList.remove("active");
        this.$el.querySelector(".raw").classList.add("active");
      } else if (view === this.EDITOR_VIEW_FORM) {
        this.$el.querySelector(".raw").classList.remove("active");
        this.$el.querySelector(".form").classList.add("active");
      }
    },
    switchToRaw: function () {
      if (!this.$refs.switch.checked) {
        return;
      }
      this.$refs.switch.checked = false;
      this.switchView(false);
    },
    switchToForm: function () {
      if (this.$refs.switch.checked) {
        return;
      }
      this.$refs.switch.checked = true;
      this.switchView(true);
    },
  },
  beforeDestroy() {
    Bus.$off("cancelSwitch");
  },
};
</script>

<style scoped>
.slider-block {
  margin: 1rem 0;
}

.form, .raw {
  cursor: pointer;
}

.active {
  color: #2196f3;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  margin: 0 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #2196f3;
  border-radius: 34px;
  transition: 0.4s;  
}

.slider:before{
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;
  left: 4px;
  bottom: 4px;
  background: white;
  border-radius: 50%;
  transition: 0.4s;
}

input:checked + .slider {
  background: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}
</style>